import React from 'react';

import { FormattedMessage } from 'react-intl';
import { di } from 'react-magnetic-di';

import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { Inline, Text } from '@atlaskit/primitives/compiled';

import { FormFieldRenderer } from './form-field-renderer';
import { HtmlRenderer } from './html-renderer';
import { messages } from './messages';
import type { FormExtensionRendererComponentType, HtmlExtensionParameters } from './types';

export const FormExtensionRenderer: FormExtensionRendererComponentType = ({
	extensionKey,
	parameters,
}) => {
	di(FormFieldRenderer, HtmlRenderer);

	const extensionId = parameters?.id;

	if (extensionId === undefined) {
		return (
			<Inline alignBlock="center">
				<StatusWarningIcon spacing="spacious" color="var(--ds-icon-danger)" label="Warning" />
				<Text color="color.text.danger">
					<FormattedMessage {...messages.extensionError} />
				</Text>
			</Inline>
		);
	}

	switch (extensionKey) {
		case 'html':
			return (
				<HtmlRenderer
					fieldId={extensionId}
					htmlContent={(parameters as HtmlExtensionParameters)?.htmlContent ?? ''}
				/>
			);
		case 'question':
			return <FormFieldRenderer fieldId={extensionId} />;
		default:
			// TODO: REQIN-1562 - Add error handling / logging
			return <></>;
	}
};
